<script setup lang="ts">
import { onMounted } from 'vue'

const { t } = useLang()
const { locale } = useI18n()
const router = useRouter()

const expText = ref('')

// 积分信息
const coinsInfo = ref({
  balance: '≈HK$0',
  amount: 0,
  monthExpire: 0,
})

async function getcoins() {
  const res = await http({
    url: '/sea_whale_api/integral/balance',
    baseURL: '/sea_shell',
    method: 'POST',
    body: {
      platform: 1,
    },
  })
  //   console.log(res)
  if (res.status === 401) {
    //   console.log(res.data)
    // console.log(getFullLink('/login'))
    $utils.messageBox(t, res?.message)
    // router.push(getFullLink('/login'))
  }
  if (res.status === 200) {
    coinsInfo.value = res.body
    if (coinsInfo.value.monthExpire > 0) {
      expText.value = t('coins.p_coins_expired_tip', {
        count: coinsInfo.value.monthExpire,
      })
    }
  }
}

function jumpTo() {
  console.log(`/${locale.value}/common/faq/?cookie=1`)
  location.href = `/${locale.value}/common/faq/?cookie=1`
  useCookie<any>('faq').value = {
    secondCategoryId: 1,
    categoryId: 340,
    questionId: 1,
  }
}

onMounted(() => {
  getcoins()
})
</script>

<template>
  <div class="point-banner">
    <div class="banner-content text-white flex">
      <div class="title font-extrabold">
        <section class="text-[20px] mb-[56px] flex leading-1 items-center">
          <p class="font-bold">
            {{ t('coins.p_coins_title') }}
          </p>
          <p v-if="expText" class="exp-tip text-[16px]">
            {{ expText }}
          </p>
        </section>
        <section class="flex items-end text-[20px] leading-1">
          <p>
            <span class="text-[40px] mr-[10px]">{{ coinsInfo.amount }}</span
            ><span>G-Coins</span>
            <span class="text-[#faff00] ml-[10px]">{{ coinsInfo.balance }}</span>
          </p>
          <p @click="jumpTo">
            <img src="~/assets/img/coins/info.png" class="info" alt="point-info-icon" />
          </p>
        </section>
      </div>
      <div class="icon">
        <img src="~/assets/img/coins/coins.png" alt="point-banner-icon" />
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.point-banner {
  width: 100%;
  height: 240px;
  background-color: #ff6b00;
  align-items: center;
  display: flex;

  .banner-content {
    width: 870px;
    margin: 0 auto;
    align-items: center;
    justify-content: space-between;

    .title {
      line-height: 1;
    }

    .icon img {
      width: 180px;
      height: 180px;
      display: block;
    }
  }

  .exp-tip {
    height: 32px;
    line-height: 32px;
    padding: 0 16px;
    background: #ffefd6;
    color: #ff6b00;
    border-radius: 8px;
    margin-left: 16px;
  }

  .info {
    height: 20px;
    width: 20px;
    // marign-top: -2px;
    transform: translate(0, -3px);
    margin-left: 10px;
  }
}
</style>
